"use strict";

function $t(key, options) {
  if ($.t) {
    return $.t(key, options);
  } else {
    return key;
  }
}

function $l(date) {
  return date.format('%x %X');
}

function orientationUpdate(event) {
  var portrait;
  if (event) portrait = event.orientation == "portrait";else portrait = window.innerHeight > window.innerWidth;

  if (portrait) {
    $(".landscape-left").removeClass('keep-left');
    $(".landscape-only").hide();
    $(".portrait-only").show();
  } else {
    $(".landscape-left").addClass('keep-left');
    $(".landscape-only").show();
    $(".portrait-only").hide();
  }

  if ($.mobile.activePage.attr('id') == "vitals") {
    reloadGraphs();
  }

  Interviews.orientationChange($.mobile.activePage);
}

var RIPPLE_OPTIONS = {
  color: '#dbdbdb',
  detectBrightness: true,
  duration: 300,
  buttonWait: 200
};
function addRipple(elements) {

  if (inBrowser) {
    RIPPLE_OPTIONS.duration = 750;
  }

  $(elements).each(function (index) {
    $(this).rippleria(RIPPLE_OPTIONS);
  });
}

function addLongTap(parent) {
  $("a[onclick]", parent).bind("taphold", function (event) {
    event.preventDefault();
    $(event.target).click();
  });
}

function formatNextDate(date) {
  var now = new Date();
  var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  var tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  if (date.format('%x') == today.format('%x')) return $t('dates.names.today');else if (date.format('%x') == tomorrow.format('%x')) return $t('dates.names.tomorrow');else return date.format('%a %x');
}

function formatPrevDate(date) {
  var now = new Date();
  var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  var yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
  if (date.format('%x') == today.format('%x')) return $t('dates.names.today');else if (date.format('%x') == yesterday.format('%x')) return $t('dates.time_ago.yesterday');else return date.format('%a %x');
}

function numbersonly(myfield, e, places, allowneg, maxLength, decVal) {
  var allowdec = places > 0;
  var allowed_separator = $t("numbers.decimal_separator");

  var key;
  var keychar;
  var customDec = false;

  if (allowdec && decVal) {
    customDec = true;
    allowed_separator = decVal;
  }

  if (e.ctrlKey == 1) return true;

  if (window.event) key = window.event.keyCode;else if (e) key = e.which;else return true;

  // control keys FF sends these through
  if (key == null || key == 0 || key == 8 || key == 9 || key == 13 || key == 27) return true;

  keychar = String.fromCharCode(key);
  if (keychar == ".") {
    keychar = allowed_separator;
  }

  var fieldVal = myfield.value.replace(".", allowed_separator);

  if ("0123456789".indexOf(keychar) > -1) // numbers 
    {
      var len = fieldVal.length;
      if (allowdec) {
        var parts = fieldVal.split(allowed_separator);
        if (parts.length == 2 && parts[1].length >= places && myfield.selectionStart > parts[0].length) return false;

        if (parts.length == 2) {
          len = parts[1].length + parts[0].length;
        }
      }
      if (len >= maxLength) {
        return false;
      }
      return true;
    } else if (allowdec && keychar == allowed_separator) // decimal point
    {
      return fieldVal.indexOf(allowed_separator) < 0; //make sure there is not already a decimal
    } else if (allowneg && keychar == "+") {
    if (fieldVal.indexOf("-") == 0 && !inBrowser) {
      myfield.value = myfield.value.replace("-", "");
    }
    return false;
  } else if (allowneg && keychar == "-") {
    if (fieldVal.indexOf("-") == 0) {
      if (!inBrowser) {
        myfield.value = myfield.value.replace("-", "");
      }
      return false;
    } else if (myfield.selectionStart != 0) {
      myfield.value = "-" + myfield.value;
      return false;
    } else {
      return true;
    }
    return fieldVal.indexOf("-") == -1; //make sure there is not already a - at the start
  } else {
    return false;
  }
}

function filterNumberChars(input, places, allowNegative) {
  var allowed_separator = $t("numbers.decimal_separator");

  var text = input.value.replace(/\./g, allowed_separator);
  var originalText = input.value;
  var saveSel;
  var selLen;
  if (input.type != "number") {
    saveSel = input.selectionStart;
    selLen = input.selectionEnd - input.selectionStart;
  }

  var allowDecimal = places > 0;
  if (!allowDecimal && !allowNegative) {
    text = text.replace(/\D/g, "");
  } else if (allowDecimal && allowNegative) {
    var re = new RegExp("[^0-9\\" + allowed_separator + "\\-]+", "g");
    text = text.replace(re, '');
  } else if (allowDecimal) {
    var re = new RegExp("[^0-9\\" + allowed_separator + "]+", "g");
    text = text.replace(re, '');
  } else if (allowNegative) {
    text = text.replace(/[^0-9\-]+/g, '');
  }
  var re = new RegExp("^([+-]?\d*[\\" + allowed_separator + "]\d+)$");
  if ($.trim(text).search(re) != -1) {
    text = filterNumber(text, places, allowNegative);
  }

  if (originalText != text) {
    var sizeDiff = text.length - input.value.length;
    input.value = text;
    if (input.type != "number") {
      input.selectionStart = saveSel;
      input.selectionEnd = saveSel + selLen + sizeDiff;
    }
  }
}

function filterNumber(text, places, allowNegative) {
  var allowDecimal = places > 0;
  var neg = false;
  if (allowNegative) {
    var negtext = $.trim(text);
    if (negtext.length > 1 && negtext.charAt(0) == "-") {
      neg = true;
    }
  }

  if (!allowDecimal) {
    text = text.replace(/\D/g, "");
  } else {
    var allowed_separator = $t("numbers.decimal_separator");

    text = $.trim(text);
    text = text.replace(/\./g, allowed_separator);
    var lastDotIndex = text.lastIndexOf(allowed_separator);

    if (lastDotIndex < 0 || lastDotIndex == text.length - 1) {
      text = text.replace(/\D/g, "");
    } else {
      var left = text.substring(0, lastDotIndex).replace(/\D/g, "");
      var right = text.substring(lastDotIndex).replace(/\D/g, "");
      if (right.length > places) right = right.substring(0, places);
      text = left;
      if (right != "") text += allowed_separator + right;
    }
  }

  if (neg && text.length > 0) text = "-" + text;

  return text;
}

function formatNumber(num, format_precision) {

  var precision = format_precision == null ? 2 : format_precision;
  var separator = $t("numbers.decimal_separator");
  var delimiter = $t("numbers.thousands_separator");

  if (typeof num == "string") {
    var n_str = num;
  } else {
    var n_str = num.toFixed(precision);
  }

  n_str += '';
  var x = n_str.split('.');

  var x1 = x[0];
  var x2 = x.length > 1 ? separator + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (delimiter && delimiter !== "" && rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + delimiter + '$2');
  }

  return x1 + x2;
}

/*
 * JavaScript Pretty Date
 * Copyright (c) 2011 John Resig (ejohn.org)
 * Licensed under the MIT and GPL licenses.
 */

function prettyDate(date) {
  var diff = (new Date().getTime() - date.getTime()) / 1000,
      day_diff = Math.floor(diff / 86400);

  if (isNaN(day_diff) || day_diff < 0 || day_diff >= 31) return date.format('%x');

  return day_diff == 0 && (diff < 60 && $t("dates.time_ago.just_now") || diff < 120 && $t("dates.time_ago.1_minute_ago") || diff < 3600 && Math.floor(diff / 60) + " " + $t("dates.time_ago.minutes_ago") || diff < 7200 && $t("dates.time_ago.1_hour_ago") || diff < 86400 && Math.floor(diff / 3600) + " " + $t("dates.time_ago.hours_ago")) || day_diff == 1 && $t("dates.time_ago.yesterday") || day_diff < 7 && day_diff + " " + $t("dates.time_ago.days_ago") || day_diff < 31 && Math.ceil(day_diff / 7) + " " + $t("dates.time_ago.weeks_ago");
}

var globalRsa = null;

function encrypt(data) {
  if (mymobileConfig.publicKey != null) {
    if (globalRsa == null) {
      var rawKey = pidCryptUtil.stripLineFeeds(mymobileConfig.publicKey);
      rawKey = rawKey.replace("-----BEGIN PUBLIC KEY-----", "");
      rawKey = rawKey.replace("-----END PUBLIC KEY-----", "");
      var key = pidCryptUtil.decodeBase64(rawKey);
      //new RSA instance
      globalRsa = new pidCrypt.RSA();
      //RSA encryption
      //ASN1 parsing
      var asn = pidCrypt.ASN1.decode(pidCryptUtil.toByteArray(key));
      var tree = asn.toHexTree();
      //setting the public key for encryption
      globalRsa.setPublicKeyFromASN(tree);
    }

    var rng = new SecureRandom();
    var rand = new Array(256);
    rng.nextBytes(rand);
    var password = pidCryptUtil.byteArray2String(rand);

    var aes = new pidCrypt.AES.CBC();
    var kiv = aes.createKeyAndIv({ password: password, bits: 256 });

    var enc_password = globalRsa.encrypt(kiv.iv + kiv.key);

    aes.initByValues(pidCryptUtil.toByteArray(data), kiv.key, kiv.iv, { nBits: 256 });
    aes.pidcrypt.setParams({ dataIn: data, encryptIn: pidCryptUtil.toByteArray(data) });
    var val = aes.encryptRaw();
    val = pidCryptUtil.encodeBase64(val);

    var lenStr = ("0000" + enc_password.length.toString(16)).slice(-4);

    return lenStr + enc_password + val;
  } else {
    return data;
  }
}

function maxLengthCheck(object) {
  if (object.value.length > object.maxLength) object.value = object.value.slice(0, object.maxLength);
}

function isNumeric(evt) {
  var theEvent = evt || window.event;
  var key = theEvent.keyCode || theEvent.which;
  key = String.fromCharCode(key);
  var regex = /[0-9]|\./;
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
}